import { Pedido, PedidoItem } from "@fixeduy/restaurantestypes";
import EscPosEncoder from "esc-pos-encoder";
declare const qz: any;

export async function imprimirComanda({
  pedido,
  lineas,
  titulo,
  sector,
  ip,
  port,
  agruparItems = false
}: {
  pedido: Pedido;
  lineas: PedidoItem[];
  sector: string;
  ip: string;
  port: number;
  titulo?: string;
  agruparItems?: boolean;
}) {
  const encoder = new EscPosEncoder();
  encoder.initialize();
  encoder.codepage("cp858");

  encoder.align("left").line("");
  // Filtrar por sector
  const lineasFiltradas = lineas.filter(l =>
    l.impresionSectores?.includes(sector)
  );
  if (lineasFiltradas.length === 0) return;

  const lineasParaImprimir = agruparItems
    ? agruparLineas(lineasFiltradas)
    : lineasFiltradas;

  // Título y sector
  if (titulo) encoder.align("center").bold(true).line(titulo);
  if (sector) encoder.align("center").bold(true).line(sector.toUpperCase());
  encoder.newline();

  // Encabezado
  encoder
    .align("center")
    .width(1)
    .height(1)
    .bold(true)
    .line(`Mesa: ${pedido.mesaNombre}`)
    .bold(false)
    .line(`Pedido #${pedido.numero}`)
    .line(`Fecha: ${formatearFecha(new Date())}`);

  separador(encoder);

  // Observaciones
  if (pedido.observaciones) {
    encoder
      .line("-----------------------------")
      .bold(true)
      .width(2)
      .height(2)
      .line("Observaciones:")
      .bold(false)
      .line(pedido.observaciones)
      .newline();
  }

  // Líneas de pedido
  encoder.align("left");
  lineasParaImprimir.forEach(linea => {
    encoder.newline();
    encoder
      .bold(true)
      .width(3)
      .height(3)
      .line(`${linea.cantidad}x ${linea.nombre}`);
    if (linea.observaciones) {
      encoder.width(2).height(2).line(`  - ${linea.observaciones}`);
    }
  });

  encoder.newline().newline().newline().newline();
  encoder.cut();

  // -------------------------------------------------
  // QZ Tray: conectar, enviar ticket, desconectar
  // -------------------------------------------------
  try {
    if (!qz.websocket.isActive()) {
      await qz.websocket.connect();
    }

    const bytes = encoder.encode();
    const hexData = Array.from(bytes)
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");

    const config = qz.configs.create({
      type: "raw",
      host: ip, // IP de la impresora
      port: port,
      encoding: "UTF-8"
    });
    const data = [{ type: "raw", format: "hex", data: hexData }];

    await qz.print(config, data);
  } catch (err) {
    console.error("Error al imprimir:", err);
  } finally {
    if (qz.websocket.isActive()) {
      await qz.websocket.disconnect();
    }
  }
}

// ---------------- funciones auxiliares ----------------
function separador(encoder: EscPosEncoder) {
  encoder.newline();
  encoder.line("-----------------------------");
  encoder.newline();
}

function formatearFecha(date: Date) {
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
}

export function agruparLineas(lineas: PedidoItem[]): PedidoItem[] {
  const map: Record<string, PedidoItem> = {};
  lineas.forEach(l => {
    const key = `${l.nombre}__${l.observaciones || ""}`;
    if (!map[key]) map[key] = { ...l };
    else map[key].cantidad += l.cantidad;
  });
  return Object.values(map);
}
